import { observable, runInAction } from 'mobx';

export type TeamChatMember = {
  readonly userId: number;
  readonly name: string;
  readonly isOwner: boolean;
};

/** The people each open team chat composer can mention, by its draft id */
const membersByDraftId = observable.map<string, readonly TeamChatMember[]>();

export const teamChatMembersOf = (
  draftId: string | undefined
): readonly TeamChatMember[] =>
  draftId === undefined ? [] : (membersByDraftId.get(draftId) ?? []);

export const registerTeamChatMembers = (
  draftId: string,
  members: readonly TeamChatMember[]
) => {
  runInAction(() => membersByDraftId.set(draftId, members));
  return () => {
    runInAction(() => membersByDraftId.delete(draftId));
  };
};
